import React, { useState, useEffect, useRef } from 'react';
import './DIYKits.css';

var KITS = [
  { id: 1,  name: 'Arduino Starter Kit',                 price: 2500, original: 2750, discount: 9,  link: 'https://ibots.in/product/arduino-starter-kit/',               img: 'https://ibots.in/wp-content/uploads/2024/07/WhatsApp-Image-2026-02-26-at-1.52.48-PM.jpeg' },
  { id: 2,  name: 'Arduino Intermediate Kit',            price: 5000, original: 5250, discount: 5,  link: 'https://ibots.in/product/arduino-intermediate-kit/',           img: 'https://ibots.in/wp-content/uploads/2024/07/WhatsApp-Image-2026-02-26-at-1.52.48-PM-5.jpeg' },
  { id: 3,  name: 'ESP Starter Kit',                    price: 2500, original: 2750, discount: 9,  link: 'https://ibots.in/product/iot-starter-kit/',                    img: 'https://ibots.in/wp-content/uploads/2024/07/WhatsApp-Image-2026-02-26-at-1.52.48-PM-2.jpeg' },
  { id: 4,  name: 'ESP Intermediate Kit',               price: 5000, original: 5250, discount: 5,  link: 'https://ibots.in/product/iot-intermediate-kit/',               img: 'https://ibots.in/wp-content/uploads/2024/07/WhatsApp-Image-2026-02-26-at-1.52.48-PM-1.jpeg' },
  { id: 5,  name: 'Wi-Fi Controlled Robot',             price: 4000, original: 4250, discount: 6,  link: 'https://ibots.in/product/wi-fi-controlled-robot/',             img: 'https://ibots.in/wp-content/uploads/2026/02/WhatsApp-Image-2026-02-26-at-10.09.14-AM.jpeg' },
  { id: 6,  name: 'Bluetooth Controlled Robot',         price: 4000, original: 4250, discount: 6,  link: 'https://ibots.in/product/bluetooth-controlled-robot/',         img: 'https://ibots.in/wp-content/uploads/2026/02/WhatsApp-Image-2026-02-26-at-10.09.14-AM-1.jpeg' },
  { id: 7,  name: 'Line Following Robot',               price: 4000, original: 4250, discount: 6,  link: 'https://ibots.in/product/line-following-robot/',               img: 'https://ibots.in/wp-content/uploads/2026/02/WhatsApp-Image-2026-02-26-at-10.09.12-AM.jpeg' },
  { id: 8,  name: 'Obstacle Avoiding Robot',            price: 4250, original: 4500, discount: 6,  link: 'https://ibots.in/product/obstacle-avoiding-robot/',            img: 'https://ibots.in/wp-content/uploads/2026/02/WhatsApp-Image-2026-02-26-at-10.09.13-AM.jpeg' },
  { id: 9,  name: '5 in 1 Robotic Kit - A',             price: 5000, original: 5250, discount: 5,  link: 'https://ibots.in/product/5-in-1-robotic-kit-a/',              img: 'https://ibots.in/wp-content/uploads/2026/02/WhatsApp-Image-2026-02-26-at-12.23.22-PM.jpeg' },
  { id: 10, name: 'Raspberry Pi Pico Starter Kit',      price: 2500, original: 2750, discount: 9,  link: 'https://ibots.in/product/raspberry-pi-pico-starter-kit/',      img: 'https://ibots.in/wp-content/uploads/2026/02/WhatsApp-Image-2026-02-26-at-1.52.48-PM-4.jpeg' },
  { id: 11, name: 'Raspberry Pi Pico Intermediate Kit', price: 5000, original: 5750, discount: 13, link: 'https://ibots.in/product/raspberry-pi-pico-intermediate-kit/', img: 'https://ibots.in/wp-content/uploads/2026/02/WhatsApp-Image-2026-02-26-at-1.52.48-PM-3.jpeg' },
  { id: 12, name: 'Tiny ML Kit',                        price: 3000, original: 3250, discount: 8,  link: 'https://ibots.in/product/tiny-ml-kit/',                        img: 'https://ibots.in/wp-content/uploads/2026/02/WhatsApp-Image-2026-02-26-at-1.59.56-PM.jpeg' },
];

var VISIBLE = 4;

function DIYKits() {
  var pair = useState(0);
  var current = pair[0];
  var setCurrent = pair[1];
  var maxIndex = KITS.length - VISIBLE;
  var shift = current * 25;
  var trackStyle = { transform: 'translateX(-' + shift + '%)' };

  var intervalRef = useRef(null);

function startAutoSlide() {
  intervalRef.current = setInterval(function () {
    setCurrent(function (prev) {
      return prev >= maxIndex ? 0 : prev + 1;
    });
  }, 1000); // change 3000 to any ms interval you want
}

function stopAutoSlide() {
  clearInterval(intervalRef.current);
}

useEffect(function () {
  startAutoSlide();
  return function () { stopAutoSlide(); };
}, []);
  function handlePrev() {
    if (current > 0) {
      setCurrent(current - 1);
    }
  }

  function handleNext() {
    if (current < maxIndex) {
      setCurrent(current + 1);
    }
  }

  function handleDot(i) {
    var target = i < maxIndex ? i : maxIndex;
    setCurrent(target);
  }

  function getDotClass(i) {
    if (i >= current && i < current + VISIBLE) {
      return 'diy__dot diy__dot--active';
    }
    return 'diy__dot';
  }

  function getLeftClass() {
    if (current === 0) {
      return 'diy__arrow diy__arrow--left diy__arrow--disabled';
    }
    return 'diy__arrow diy__arrow--left';
  }

  function getRightClass() {
    if (current === maxIndex) {
      return 'diy__arrow diy__arrow--right diy__arrow--disabled';
    }
    return 'diy__arrow diy__arrow--right';
  }

  function renderCard(kit) {
    return (
      <div className="diy__card" key={kit.id}>
        <div className="diy__img-wrap">
          <span className="diy__discount">-{kit.discount}%</span>
          <span className="diy__best">BEST seller</span>
          <img src={kit.img} alt={kit.name} className="diy__img" />
        </div>
        <div className="diy__info">
          <h3 className="diy__name">{kit.name}</h3>
          <div className="diy__price-row">
            <span className="diy__price">Rs. {kit.price.toLocaleString('en-IN')}</span>
            <span className="diy__original">Rs. {kit.original.toLocaleString('en-IN')}</span>
          </div>
          <a href={kit.link} target="_blank" rel="noopener noreferrer" className="diy__btn">
            Add to Cart
          </a>
        </div>
      </div>
    );
  }

  function renderDot(kit, i) {
    return (
      <button
        key={kit.id}
        className={getDotClass(i)}
        onClick={function() { handleDot(i); }}
      />
    );
  }

  return (
    <section className="diy__section">

      <div className="diy__header">
        <p className="diy__eyebrow">SHOP AND LEARN</p>
        <h2 className="diy__title">DIY Kits for Learning and Projects</h2>
        <p className="diy__sub">
          Everything included. No need to buy components separately.
          Perfect for students, beginners, and project enthusiasts.
        </p>
      </div>

      <div
  className="diy__carousel-wrap"
  onMouseEnter={stopAutoSlide}
  onMouseLeave={startAutoSlide}
>

        <button className={getLeftClass()} onClick={handlePrev}>
          <span className="diy__arrow-icon">←</span>
        </button>

        <div className="diy__track-outer">
          <div className="diy__track" style={trackStyle}>
            {KITS.map(renderCard)}
          </div>
        </div>

        <button className={getRightClass()} onClick={handleNext}>
          <span className="diy__arrow-icon">→</span>
        </button>

      </div>

      <div className="diy__dots">
        {KITS.map(renderDot)}
      </div>

      <div className="diy__footer">
        <a href="https://ibots.in/product-category/diy-kits/" target="_blank" rel="noopener noreferrer" className="diy__view-all">View All DIY Kits</a>
      </div>

    </section>
  );
}

export default DIYKits;